import BookShow from "components/shared/book/show";
import { viewContainer } from "helpers/redux";
import React from "react";
import { getRoute } from "sources/map";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class ShowRouteTemplate extends BookShow {
    _isMounted = false;
    get dropdActions() {
        const actions = [];
        const { canEditBooks } = this.props;
        if (canEditBooks) {
            actions.push({ text: "Удалить", action: this.actionClose });
        }
        return actions;
    }

    componentDidMount() {
        this.context?.setPrevItemId(Number(this.props.match.params.id));
        this._isMounted = true;
        const initial = this.props.initialState;
        this.setState({ data: initial, initial });
        this.getItem(this.props);
    }

    componentWillUnmount() {
        this.props.mergeMapData({ supportPoints: [], supportRoute: [] });
        this._isMounted = false;
    }

    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        source.getItem(match.params).then((data) => {
            this.setState({ data, initial: data, ...defParams });
            this.props.mergeMapData({ supportPoints: data.supportPoints, supportRoute: [] });
            const routeReqData = [];
            data.supportPoints.forEach((point, index) => {
                if (data.supportPoints[index + 1]) {
                    routeReqData.push([point, data.supportPoints[index + 1]]);
                }
            });
            Promise.all(routeReqData.map(getRoute)).then((res) => {
                if (this._isMounted) {
                    this.props.mergeMapData({ supportRoute: res.map((r) => r.concatedCoords) });
                }
            });
        });
    };

    renderBody = () => {
        const { config } = this.props;
        const props = {
            renderField: this.renderField,
            Button: this.renderButton,
        };
        return <Markup {...config} {...props} />;
    };
}

const ConfiguredShow = (props) => <ShowRouteTemplate {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "routetemplates");
